import { l } from '@manychat/manyui'

import { ReasonStatuses } from 'common/oneTimeNotify/constants/notifyReasonConstants'
import { NotificationReason } from 'shared/api/requests/notificationReason/schemas'

import { SelectOption } from './interfaces'
import { OptionsGroup, Option } from './options'

export const getReasonTitleForDropdown = (reason: NotificationReason): string => {
  return reason.status === ReasonStatuses.ARCHIVE
    ? reason.caption + ` (${l.translate('Archived')})`
    : reason.caption
}

export const transformAssigneeOptions = (groups: OptionsGroup[]): SelectOption[] => {
  return groups.reduce<SelectOption[]>((acc, group) => {
    acc.push({
      label: group.label,
      value: group.value,
      type: 'group',
    })

    const children = group.options.map((option) => ({
      label: option.label,
      value: 'id' in option.value ? option.value.id.toString() : option.value.toString(),
      rightContent: 'type' in option.value ? option.value.type : undefined,
      type: option.value.optionType,
    }))

    return acc.concat(children)
  }, [])
}

export const parseSelectedOptionValue = (
  selectedOption: Option,
): { label: string; value: string } => {
  return {
    label: selectedOption.label,
    value: 'id' in selectedOption.value ? selectedOption.value.id : '',
  }
}
